export default {
  goToPlatform: 'Ir a la Plataforma'
}



// WEBPACK FOOTER //
// ./src/App/i18n/strings/home/landing/es.js